<section>
    <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Application Claim Types Search</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Application Claim Types Search</span>
                        <button *ngIf="sharedService.checkPermission('Admin_Add')" style="height: 30px !important;width: auto!important;
                        margin-top: -2px;border-color: white;" pButton  type="button" icon="pi pi-plus" label="Add"
                            class="p-button-sm p-button-success float-right"  (click)="addClaimTypeDetails()"></button>
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
  
                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                          
                          <button [ngClass] = "showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                      </div>
                      <div class="col-md-8">
  
                          <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" style="float: right;height: 30px;" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportClaimTypes()"
                           ></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>
  
                          <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button>
                          
  
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>






<section>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12" *ngIf="isClaimTypeAdd || isClaimTypeEdit">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">{{title}}</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <form [formGroup] = "claimTypeForm">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="claimType">Claim Type<span class="required-field">*</span></label>
                                            <input id="claimType" type="text" formControlName="claimType" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="description">Claim Type Description<span class="required-field">*</span></label>
                                            <input id="description" type="text" formControlName="description" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="isActive">Is Active</label>
                                            <br />
                                            <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                                        </div>
                                    </div>
                                </form>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <button pButton pRipple type="button" label="{{buttonLabel}}" icon="pi pi-check"
                                class="p-button-sm p-button-raised p-button-success m-2" [disabled]="!this.claimTypeForm.valid" (click)="save(claimTypeForm)"></button>
                            <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                class="p-button-sm p-button-raised p-button-danger m-2" (click)="cancel()"></button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <!-- <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addClaimTypeDetails()"  *ngIf="(isClaimTypeAdd === false) && (isClaimTypeEdit === false) && sharedService.checkPermission('Admin_Add')"></button>
                                </div>
                                <div class="col-md-6">
                                </div>
                            </div>
                        </div> -->
                        <div class="devcare-table-card-header" *ngIf="showToggle">
                            <div class="row">
                                <div class="col-md-6">
            
                                </div>
                                <div class="col-md-6">
                                <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader] = "false" [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                                    <ng-template let-column pTemplate="item">
                                        <div class="column-item">
                                            <div>{{column.header}}</div>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                            <p-table #dt2 [value]="claimTypeList" [lazy]="true" paginatorDropdownAppendTo="body"
                                (onLazyLoad)="loadClaimTypeList($event)" dataKey="id" [rows]="10"
                                [showCurrentPageReport]="true"  [resizableColumns]="true" columnResizeMode="expand"
                                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines"
                                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['claimType','description','isActive','createdBy','createdOn']">
                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')">Action</th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('claimType')">Claim Type  <span pSortableColumn="claimType" *ngIf="showSorting"><p-sortIcon field="claimType"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="claimType" display="menu" #filterClaimType [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #claimType type="text" value="{{filters?.claimType[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(claimType.value);applyFilterNew(dt2);filterClaimType.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('description')">Description  <span pSortableColumn="description" *ngIf="showSorting"><p-sortIcon field="description"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="description" display="menu" #filterDescription [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #description type="text" value="{{filters?.description[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(description.value);applyFilterNew(dt2);filterDescription.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('isActive')">Is Active  <span pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="isActive" display="menu" #filterIsActive [showAddButton]="false"
                                                [showMatchModes]="false"  [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <!--<input #isActive type="text" value="{{filters?.isActive[0]?.value}}" pInputText class="pinputHeight">-->
                                                    <p-dropdown #isActive [options]="statusValues" [(ngModel)] ="selectedStatusId" (onChange)="getStatusOnChange($event)"></p-dropdown>
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="clearStatus();filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(isActive.value);applyFilterNew(dt2);filterIsActive.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>

                                            
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdBy')">Created By  <span pSortableColumn="createdBy" *ngIf="showSorting"><p-sortIcon field="createdBy"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="createdBy" display="menu" #filterCreatedBy [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #createdBy type="text" value="{{filters?.createdBy[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdBy.value);applyFilterNew(dt2);filterCreatedBy.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdOn')">Created On <span pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu" #filterCreatedOn [showAddButton]="showAddRuleButton" [showOperator]="false"  
                                            [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false" [showApplyButton]="false">
                                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                <p-calendar #createdOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [appendTo]="p-calendar"  [ngModel]="value"></p-calendar>
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdOn.value);applyFilterNew(dt2);filterCreatedOn.hide()">Apply</p-button>
                                                    </div>
                                            </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        
                                    </tr>
                                    <tr [hidden]="!showFilters">
                                        <th *ngIf="isShowColumns('action')"></th>
                                        <th *ngIf="isShowColumns('claimType')">{{filters?.claimType[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('description')">{{filters?.description[0]?.value}}</th>
                                        <!--<th *ngIf="isShowColumns('isActive')">{{filters?.isActive[0]?.value}}</th>-->
                                        <th *ngIf="isShowColumns('isActive')">{{selectedStatus}}</th>
                                        <th *ngIf="isShowColumns('createdBy')">{{filters?.createdBy[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('createdOn')">{{filters?.createdOn[0]?.value| date:'MM/dd/yyyy'}} <span *ngIf="filters?.createdOn.length > 1">-</span> {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                                    </tr>
                                </ng-template>
                               
                                <ng-template pTemplate="body" let-claimTypeList>
                                    <tr>
                                        <td *ngIf="isShowColumns('action')"> <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                                    (click)="selectedGridMenuItem = claimTypeList; menu.toggle($event)"></i></a>
                                            <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                        </td>
                                        <td *ngIf="isShowColumns('claimType')"><span class="table-col-claimType">{{claimTypeList.claimType}}</span></td>
                                        <td *ngIf="isShowColumns('description')"><span>{{claimTypeList.description}}</span></td>
                                        <td style="width: 8rem" *ngIf="isShowColumns('isActive')"><span class="customer-badge status-active" *ngIf="claimTypeList.isActive">Active</span>
                                            <span class="customer-badge status-inactive" *ngIf="!claimTypeList.isActive">Inactive</span>
                                        </td>
                                        <td *ngIf="isShowColumns('createdBy')"><span>{{claimTypeList?.createdByUser?.firstName}}</span></td>
                                        <td *ngIf="isShowColumns('createdOn')"><span>{{claimTypeList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                                        <!-- <td>
                                            <span>
                                                <a [routerLink]="" class="table-icon table-icon-edit" (click)="editClaimTypeDetails(claimTypeList.claimTypeId)"><i class="fas fa-edit"></i></a>&nbsp;&nbsp;&nbsp;
                                                <a [routerLink]="" class="table-icon table-icon-delete" (click)="deleteConfirm(claimTypeList.claimTypeId)"><i class="fas fa-trash-alt"></i></a>&nbsp;&nbsp;&nbsp;
                                                
                                            </span>
                                        </td> -->
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td [attr.colspan]="selectedColumns.length">No Claim Types found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
    <p-toast position="bottom-center"></p-toast>
</section>




